<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2185163" style="color: #82a339"><b>SPLIT PEA SOUP WITH HAM</b></p>
<p class="ext" id="d7e2185663"><b><i>This hearty old-fashioned favorite is a perfect pick-me-up on a cold blustery day.</i></b></p>
<p class="h4" id="d7e2186863" style="color: #496210"><b>Prep: 10 minutes Cook: 1 hour 15 minutes</b></p>
<p class="ul" id="d7e2187363">2 tablespoons vegetable oil</p>
<p class="ul" id="d7e2187663">2 white turnips (6 ounces each), peeled <br/> and chopped (optional)</p>
<p class="ul" id="d7e2188263">2 carrots, peeled and finely chopped</p>
<p class="ul" id="d7e2188563">2 stalks celery, finely chopped</p>
<p class="ul" id="d7e2188863">1 medium onion, finely chopped</p>
<p class="ul" id="d7e2189263">1 package (16 ounces) dry split peas, rinsed <br/> and picked through</p>
<p class="ul" id="d7e2189863">2 smoked ham hocks (1½ pounds)</p>
<p class="ul" id="d7e2191063">8 cups water</p>
<p class="ul" id="d7e2191663">1 bay leaf</p>
<p class="ul" id="d7e2192263">1 teaspoon salt</p>
<p class="ul" id="d7e2192563">¼ teaspoon ground allspice</p>
<p class="pub" id="d7e2193663" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 5-quart Dutch oven, heat oil over medium-high heat. Add turnips, if using, carrots, celery, and onion; cook, stirring frequently, until carrots are tender-crisp, about 10 minutes. Add split peas, ham hocks, water, bay leaf, salt, and allspice; heat to boiling over high heat. Reduce heat; cover and simmer 45 minutes.</p>
<p class="pub" id="d7e2196563"><span style="color: #c15b49"><b>2.</b></span> Discard bay leaf. Transfer ham hocks to cutting board; discard skin and bones. Finely chop meat. Return meat to soup. Heat through. Makes 11 cups or 6 main-dish servings.</p>
<p class="ntx" id="d7e2198763">Each serving: About 343 calories, 21g protein, 52g carbohydrate, 7g total fat (1g saturated), 3mg cholesterol, 1,174mg sodium.</p>
<p class="h4l" id="d7e2201463" style="color: #496210"><b>GERMAN LENTIL SOUP</b></p>
<p class="tx1" id="d7e2201963">Prepare as above, but omit turnips. Substitute <b>1 pound lentils,</b> rinsed and picked over, for peas, and substitute <b>½ teaspoon thyme</b> for allspice.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c64_r1.vue?f6fee390